import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilesService } from '../files-manager (deprecated)/files.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-file-previewer-dialog',
  templateUrl: './file-previewer-dialog.component.html',
  styleUrls: ['./file-previewer-dialog.component.scss'],
})
export class FilePreviewerDialogComponent implements OnInit {
  imageWidth: number = 0;
  imageHeight: number = 0;
  isVideoLoaded: boolean = false;
  smallImage: any;
  bigImage: any;
  constructor(
    public dialogRef: MatDialogRef<FilePreviewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { fileSrc: string; extension: string; fileName: string },
    public filesService: FilesService,
    public transloco: TranslocoService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.calculateImageSize();
  }

  calculateImageSize() {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = this.data.fileSrc;
    img.onload = () => {
      const container = document.getElementById('zoom-container');
      const maxContainerHeight = container.clientHeight; // Max height is 78vh
      const maxContainerWidth = container.clientWidth; // Subtracting 50px for padding/margins

      const imageRatio = img.width / img.height;
      const containerRatio = maxContainerWidth / maxContainerHeight;

      // Determine image dimensions to fit container without cropping
      if (imageRatio > containerRatio) {
        // Image is wider than container ratio; fit to width
        this.imageWidth = maxContainerWidth;
        this.imageHeight = maxContainerWidth / imageRatio;
      } else {
        // Image is taller than container ratio; fit to height
        this.imageHeight = maxContainerHeight;
        this.imageWidth = maxContainerHeight * imageRatio;
      }

      if (img.width > maxContainerWidth || img.height > maxContainerHeight) {
        this.bigImage = this.convertImageToSafeUrl(img);
      } else {
        let image2 = img;
        image2.width = this.imageWidth;
        image2.height = this.imageHeight;
        this.bigImage = this.convertImageToSafeUrl(image2);
      }
      let image1 = img;
      image1.width = this.imageWidth;
      image1.height = this.imageHeight;
      this.smallImage = this.convertImageToSafeUrl(image1);
    };
  }

  convertImageToSafeUrl(image: HTMLImageElement, isBig: boolean = false): SafeUrl {
    if (isBig) {
      image.width = image.width * 2;
      image.height = image.height * 2;
    }
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');

    if (context) {
      context.drawImage(
        image,
        0,
        0,
        isBig ? canvas.width * 2 : canvas.width,
        isBig ? canvas.height * 2 : canvas.height,
      );
      const base64String = canvas.toDataURL();
      return this.sanitizer.bypassSecurityTrustUrl(base64String); // This returns a SafeUrl
    }

    throw new Error('Unable to get canvas context');
  }

  onClose(): void {
    this.dialogRef.close();
  }

  downloadFile(filePath: string, fileName: string): void {
    this.filesService.download(filePath, fileName);
  }

  onVideoLoaded() {
    this.isVideoLoaded = true;
  }
}
